import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";

export const Pricing = ({ content }) => {
  const p = content.pricing;
  if (!p) return null;

  return (
    <section id="harga" data-testid="pricing-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-sky-100 text-sky-700 text-sm font-semibold mb-4">
            Harga Program
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">{p.title}</h2>
          <p className="mt-4 text-base text-slate-500 leading-relaxed">{p.subtitle}</p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 items-start">
          {p.packages.map((pkg, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`pricing-card-${i}`}
              className={`relative rounded-3xl p-8 border transition-all duration-300 hover:-translate-y-2 ${
                pkg.popular
                  ? "bg-gradient-to-br from-sky-600 to-sky-800 text-white border-sky-600 shadow-2xl shadow-sky-500/30 md:-mt-4"
                  : "bg-white text-slate-900 border-slate-200 shadow-lg shadow-slate-200/50"
              }`}
            >
              {pkg.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 px-4 py-1.5 rounded-full bg-amber-400 text-slate-900 text-xs font-bold shadow-lg">
                  <Star className="w-3.5 h-3.5 fill-slate-900" /> Paling Populer
                </div>
              )}
              <h3 className={`text-xl font-bold ${pkg.popular ? "text-white" : "text-slate-900"}`}>
                {pkg.name}
              </h3>
              <div className="mt-4 flex items-end gap-1">
                <span className={`text-sm font-semibold ${pkg.popular ? "text-sky-200" : "text-slate-400"}`}>
                  Rp
                </span>
                <span className="text-4xl font-extrabold tracking-tight">{pkg.price}</span>
                <span className={`text-sm ${pkg.popular ? "text-sky-200" : "text-slate-400"}`}>
                  {pkg.period}
                </span>
              </div>
              <ul className="mt-6 space-y-3">
                {pkg.features.map((f, fi) => (
                  <li key={fi} className="flex items-start gap-3">
                    <span
                      className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${
                        pkg.popular ? "bg-white/20" : "bg-sky-100"
                      }`}
                    >
                      <Check className={`w-3 h-3 ${pkg.popular ? "text-white" : "text-sky-600"}`} />
                    </span>
                    <span className={`text-sm ${pkg.popular ? "text-sky-50" : "text-slate-600"}`}>{f}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
